import { render, staticRenderFns } from "./DialogUsersAndCategoryEditUser.vue?vue&type=template&id=48ba6201"
import script from "./DialogUsersAndCategoryEditUser.vue?vue&type=script&lang=js"
export * from "./DialogUsersAndCategoryEditUser.vue?vue&type=script&lang=js"
import style0 from "./DialogUsersAndCategoryEditUser.vue?vue&type=style&index=0&id=48ba6201&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports